<section class="reader">
  <header class="reader__topbar">
    <button class="btn btn--ghost" type="button" (click)="back()">← Back</button>
    <button class="btn btn--home" type="button" (click)="home()">🏠 Home</button>
  </header>

  <!-- Loading -->
  <div *ngIf="loading" class="state">
    <div class="ph ph--banner"></div>
    <div class="ph ph--line"></div>
  </div>

  <!-- Error -->
  <div *ngIf="!loading && loadError" class="state state--error">
    <p>Unable to load the issue.</p>
    <button class="btn" type="button" (click)="back()">Go back</button>
  </div>

  <!-- Content -->
  <ng-container *ngIf="!loading && !loadError && issue as it">
    <header class="reader__header">
      <h1 class="reader__title">{{ it.title }}</h1>
      <div class="reader__meta">
        <span class="date" *ngIf="it.publish_date">{{ formatDate(it.publish_date) }}</span>
        <span class="cat" *ngIf="it.category">{{ it.category }}</span>
      </div>
      <p class="reader__desc" *ngIf="it.description">{{ it.description }}</p>
    </header>

    <div class="reader__preview">
      <div class="preview__cover" *ngIf="it.cover_path">
        <img [src]="it.cover_path" [alt]="it.title" loading="lazy" />
      </div>

      <div class="preview__actions">
        <button class="btn" type="button" [disabled]="!it.pdf_path" (click)="openPdf()">
          Open PDF
        </button>
      </div>
    </div>
  </ng-container>
</section>
